const SvgFemale = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		shapeRendering="geometricPrecision"
		textRendering="geometricPrecision"
		imageRendering="optimizeQuality"
		fillRule="evenodd"
		clipRule="evenodd"
		viewBox="0 0 361 511.42"
		width="1em"
		height="1em"
	>
		<path
			fillRule="nonzero"
			d="M203.64 359.53v44.17h78.58v52.94h-78.58v54.78H150.7v-54.78H72.13V403.7h78.57v-45.15c-37.91-6.3-71.82-24.41-97.83-50.42C20.21 275.47 0 230.35 0 180.5c0-49.84 20.21-94.97 52.87-127.63S130.65 0 180.5 0c49.84 0 94.97 20.21 127.63 52.87S361 130.66 361 180.5c0 49.84-20.21 94.97-52.87 127.63-27.52 27.52-63.9 46.2-104.49 51.4zM270.7 90.3c-23.08-23.08-54.98-37.36-90.2-37.36-35.23 0-67.12 14.28-90.2 37.36s-37.36 54.98-37.36 90.2c0 35.23 14.28 67.12 37.36 90.2s54.97 37.36 90.2 37.36c35.22 0 67.12-14.28 90.2-37.36s37.36-54.97 37.36-90.2c0-35.22-14.28-67.12-37.36-90.2z"
		/>
	</svg>
)

export default SvgFemale
